angular.module('TetherApp').factory('listService', [
    '$http',
    function ($http) {
        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let indexList = function () {
            let uri = '/api/v1/lists/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let addParticipantToList = function (listId, participantId) {
            return $http.post(
                '/api/v1/list/participant/' + listId,
                {
                    participant_id: participantId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let addParticipantsToList = function (listId, participantIds) {
            return $http.post(
                '/api/v1/list/participants/' + listId,
                {
                    participant_ids: participantIds
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let createList = function (list) {
            return $http.post(
                '/api/v1/lists',
                list,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let readList = function (listId) {
            let uri = '/api/v1/lists/' + listId + '/show';
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let editList = function (listId, list) {
            return $http.put(
                '/api/v1/lists/' + listId ,
                list,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteList = function (listId) {
            let uri = '/api/v1/lists/' + listId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getUsersLists = function () {
            let uri = '/api/v1/users/lists/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getUsersListParticipants = function (listId, data) {
            let uri = '/api/v1/users/lists/participants/' + listId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getPinned = function (queryData) {
            let uri = '/api/v1/lists/pinned/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: queryData
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getNotPinned = function (queryData) {
            let uri = '/api/v1/lists/not-pinned/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: queryData
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let removeParticipantFromList = function (listId, participantId) {
            return $http.post(
                '/api/v1/list/participant/' + listId + '/remove',
                {
                    participant_id: participantId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let removeParticipantsFromList = function (listId, participantIds) {
            return $http.post(
                '/api/v1/list/participants/' + listId + '/remove',
                {
                    participant_ids: participantIds
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let searchExistingParticipants = function (id, queryData) {
            let uri = '/api/v1/users/lists/participants/search/existing/' + id + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: queryData
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            indexList: indexList,
            addParticipantToList: addParticipantToList,
            addParticipantsToList: addParticipantsToList,
            createList: createList,
            readList: readList,
            deleteList: deleteList,
            editList: editList,
            getUsersLists: getUsersLists,
            getUsersListParticipants: getUsersListParticipants,
            getPinned: getPinned,
            getNotPinned: getNotPinned,
            removeParticipantFromList: removeParticipantFromList,
            removeParticipantsFromList: removeParticipantsFromList,
            searchExistingParticipants: searchExistingParticipants
        }
    }
]);
